import styled from 'react-emotion'
import color from 'color'
import { Link } from 'react-router-dom'

export const Button = styled('button')`
  border: 0;
  outline: none;
  border-radius: 0.3em;
  background-color: ${props => props.disabled
    ? color(props.theme.primaryColor).darken(0.55).hex()
    : props.theme.primaryColor};
  color: ${props => props.disabled ? '#BDA1A7' : '#FCFCFC'};
  padding: .9em 2em;
  font-size: 0.95em;
  margin: 1em 0;

  display: ${props => props.block ? 'block' : 'inline'};
  width: ${props => props.block ? '100%' : 'auto'};

  &:hover {
    background-color: ${props => props.disabled
    ? color(props.theme.primaryColor).darken(0.55).hex()
    : color(props.theme.primaryColor).darken(0.15).hex()};
  }

  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`

export const TransparentButton = styled('button')`
  border: 0;
  padding: .4em 0;
  background: transparent;
  cursor: pointer;
  text-transform: uppercase;
  font-size: .95em;
  color: ${(props) => props.color || props.theme.primaryColor};
  outline: none;
  margin: ${({ first, last }) => (
    first
      ? '0 1em 0 0'
      : last
        ? '0 0 0 1em'
        : '0 1em'
  )};
  margin-top: 1em;
`

export const AppLinkButton = styled(Link)`
  font-size: .9em;
  color: ${props => props.theme.primaryColor};
`
